import SenderPersonaForm from "../../_components/SenderPersonaForm";
import { useParams } from "react-router-dom";
import { PageAccessGuard } from "@/components/auth/PageAccessGuard";

const SenderPersonaDetailsPage: React.FC = () => {
  return (
    <PageAccessGuard authority="ADMIN_SENDER_PERSONA_VIEW">
      <SenderPersonaDetailsContent />
    </PageAccessGuard>
  );
};

const SenderPersonaDetailsContent: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  return <SenderPersonaForm mode="view" personaId={id} readOnly={true} />;
};

export default SenderPersonaDetailsPage;
